import React, { useState } from "react";
import axios from "axios";
import { API_URL } from "../config";
import {
  Box,
  Stack,
  Typography,
  Button,
  CircularProgress,
} from "@mui/material";
import { FaFilePdf, FaUpload } from "react-icons/fa";
import { toast } from "react-toastify";

export default function UploadExamPDF({ subId,fetchData }) {
  const token = JSON.parse(localStorage.getItem("authToken"));
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUpload = async () => {
    if (!file) return toast.error("Please select a PDF file first.");

    const formData = new FormData();
    formData.append("file", file);

    try {
      setLoading(true);
      const res = await axios.post(
        `${API_URL}/upload-exam-pdf/${subId}/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: token ? `Bearer ${token.access}` : "",
          },
        },
      );
      await fetchData();
      toast.success(res.data.message || "File uploaded successfully.");
    } catch (err) {
      console.error(err.response?.data || err.message);
      toast.error("Error uploading file");
    } finally {
      setLoading(false);
    }
  };

 return (
   <Box>
     <Stack
       direction={{ xs: "column", sm: "row" }}
       alignItems={{ xs: "flex-start", sm: "center" }}
       spacing={2}
       flexWrap="wrap"
     >
       {/* File picker */}
       <Box
         component="label"
         sx={{
           flex: 1,
           minWidth: 200,
           display: "flex",
           alignItems: "center",
           gap: 1.5,
           px: 2,
           py: 1.2,
           borderRadius: 2,
           border: "1.5px dashed rgba(239,68,68,0.35)",
           background: "rgba(239,68,68,0.03)",
           cursor: "pointer",
           transition: "all 0.2s",
           "&:hover": {
             borderColor: "#ef4444",
             background: "rgba(239,68,68,0.07)",
           },
         }}
       >
         <Box
           sx={{
             width: 32,
             height: 32,
             borderRadius: 1.5,
             background: "rgba(239,68,68,0.1)",
             border: "1px solid rgba(239,68,68,0.2)",
             display: "flex",
             alignItems: "center",
             justifyContent: "center",
             flexShrink: 0,
           }}
         >
           <FaFilePdf size={14} color="#ef4444" />
         </Box>
         <Box sx={{ flex: 1, minWidth: 0 }}>
           <Typography
             sx={{
               fontSize: "0.78rem",
               fontWeight: 700,
               color: "#0c1a2e",
               lineHeight: 1.2,
             }}
           >
             {file ? file.name : "Choose PDF file"}
           </Typography>
           <Typography variant="caption" sx={{ color: "#94a3b8" }}>
             {file
               ? `${(file.size / 1024).toFixed(1)} KB`
               : "Click to browse — PDF only"}
           </Typography>
         </Box>
         <input
           type="file"
           accept="application/pdf"
           onChange={handleFileChange}
           style={{ display: "none" }}
         />
       </Box>

       {/* Upload button */}
       <Button
         onClick={handleUpload}
         disabled={loading || !file}
         variant="contained"
         startIcon={loading ? null : <FaUpload size={12} />}
         sx={{
           borderRadius: 2,
           textTransform: "none",
           fontWeight: 700,
           fontSize: "0.82rem",
           px: 2.5,
           whiteSpace: "nowrap",
           background:
             loading || !file
               ? "#e2e8f0"
               : "linear-gradient(135deg, #ef4444, #f87171)",
           color: loading || !file ? "#94a3b8" : "#fff",
           boxShadow:
             loading || !file
               ? "none"
               : "0 4px 12px rgba(239,68,68,0.25)",
           "&:hover": {
             background:
               loading || !file
                 ? "#e2e8f0"
                 : "linear-gradient(135deg, #dc2626, #ef4444)",
           },
           "&:disabled": { color: "#94a3b8", background: "#e2e8f0" },
         }}
       >
         {loading ? (
           <Stack direction="row" alignItems="center" spacing={1}>
             <CircularProgress size={14} sx={{ color: "#94a3b8" }} />
             <span>Uploading…</span>
           </Stack>
         ) : (
           "Upload"
         )}
       </Button>
     </Stack>
   </Box>
 );
}
